import { UseMutationOptions } from '@tanstack/react-query';

import useMutation from 'hooks/useMutation';
import { ApiMethods, CuredApiPaths } from 'models/enums';

import MutationKeys from './keys';

export type CloneCampaignResponse = { id: string };

/**
 * Duplicates an existing published campaign into a new draft.
 * - POST /campaigns/:campaignId/clone (no body) → { id } of the new draft campaign
 * @param campaignId the UUID of the source campaign to clone
 * @param mutateOptions react-query useMutation options (e.g. onSuccess to invalidate the list)
 * @returns the react-query useMutation result
 * See https://react-query-v3.tanstack.com/reference/useMutation for options and return value
 */
const useCloneCampaign = (
    campaignId: string,
    mutateOptions?: UseMutationOptions<CloneCampaignResponse, Error, void>
) => {
    const path = `${CuredApiPaths.CAMPAIGNS}/${campaignId}/clone`;

    return useMutation<void, CloneCampaignResponse>(MutationKeys.CLONE_CAMPAIGN, path, mutateOptions, ApiMethods.POST);
};

export default useCloneCampaign;
